$(() => {

    const width = Math.max($(window).width(), window.innerWidth);
    // product gallery
    const maxImages = Math.max($('.js-product-thumbslider').find('img').length, 4);
    if ($('.js-product-thumbslider').length > 0) {
        const galleryThumbs = new Swiper('.js-product-thumbslider', {
            spaceBetween: 30,
            slidesPerGroup: 1,
            loop: true,
            loopedSlides: 3,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            watchOverflow: true,
            breakpoints: {
                750: {
                    direction: 'vertical',
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                1000: {
                    direction: 'horizontal',
                    slidesPerView: 4
                },
                1150: {
                    direction: 'vertical',
                    slidesPerView: Math.min(5, maxImages),
                }
            }
        });
        const galleryMain = new Swiper('.js-product-bigslider', {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 15,
            speed: 500,
            loop: true,
            loopedSlides: 3,
            watchOverflow: true,
            pagination: {
                el: '.js-product-gallery-pager',
                type: 'bullets'
            },
            navigation: {
                nextEl: '.js-product-gallery-next',
                prevEl: '.js-product-gallery-prev',
            },
            thumbs: {
                swiper: galleryThumbs,
            }
        });
    } else {
        const galleryMain = new Swiper('.js-product-bigslider', {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 15,
            speed: 500,
            loop: true,
            loopedSlides: 3,
            watchOverflow: true,
            pagination: {
                el: '.js-product-gallery-pager',
                type: 'bullets'
            },
            navigation: {
                nextEl: '.js-product-gallery-next',
                prevEl: '.js-product-gallery-prev',
            },
        });
    }

    // product complect
    const productComplectSwiper = new Swiper('.js-product-complect', {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        slidesOffsetBefore: 12,
        slidesOffsetAfter: 12,
        spaceBetween: 30,
        speed: 650,
        watchOverflow: true,
        navigation: {
            nextEl: '.js-product-complect-next',
            prevEl: '.js-product-complect-prev',
        },
        breakpoints: {
            750: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            },
            1000: {
                slidesPerView: 4,
                slidesPerGroup: 4,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            },
            1150: {
                slidesPerView: 5,
                slidesPerGroup: 5,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            }
        }
    });

    // product tabs
    $('body').on('click', '.js-product-tab-spec', () => {
        $('.js-tab-link[href="#spec"]').trigger('click');
    });

    function checkActiveTab() {
        if(width < 768){
            /*$('.js-tab-content').removeClass('is-active');
            $('.js-tab-header').removeClass('is-active');*/
        } else {
            if($('.js-tab-content.is-active').length){
                const tab = $('.js-tab-link.is-active').attr('href');
                $('.js-tab-content').attr('style', '');
                $(tab).addClass('is-active');
                $(tab).prev('.js-tab-header').addClass('is-active');
            }
        }
    }
    checkActiveTab();

    $('body').on('click', '.js-tab-link', function(e) {
        e.preventDefault();
        const $this = $(this);
        const tab = $this.attr('href');

        $this.closest('.js-tabs').find('.js-tab-content').removeClass('is-active');
        $('.js-tab-link').not(this).removeClass('is-active');
        $this.addClass('is-active');
        $(tab).addClass('is-active');

        $this.closest('.js-tabs').find('.js-tab-header').removeClass('is-active');
        $(tab).prev('.js-tab-header').addClass('is-active');

    });

    $('body').on('click', '.js-tab-header', function(e){
        e.preventDefault();
        const $this = $(this);
        const tab = $this.attr('href');

        $('.js-tab-header').not(this).removeClass('is-active').next('.js-tab-content').removeClass('is-active').slideUp(400);
        $this.toggleClass('is-active');
        $(tab).slideToggle(400);

        setTimeout(function(){
            if($this.hasClass('is-active')){
                $('html, body').stop().animate({
                    scrollTop: ($this.offset().top - $('.header').height())
                }, 400);
            }
            $(tab).removeClass('is-active');
        }, 500);

        $('.js-tabs').find('.js-tab-link').removeClass('is-active');
        $(`.js-tab-link[href="${tab}"]`).toggleClass('is-active');
    });

    $(window).on("resize orientationchange", function() {
        checkActiveTab();
    });
    // END tabs

});

// check hash
$(window).on('load', () => {
    if(window.location.hash.indexOf("review") > -1) {
        if($(window).width() > 600){
            $('.js-tab-link[href="#reviews"]').trigger('click');

            $('html, body').stop().animate({
                scrollTop: $(window.location.hash).offset().top - $('.header').height()
            }, 450, 'easeOutQuad');
        }else{
            $('.js-tab-header[href="#reviews"]').trigger('click');
        }
    }
});
